/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert } from 'react-bootstrap';
import { ss, url, authJsonHeader, parseTimeString, mapDispatch } from '../../utils/util';

import OzFormComponent from './OzFormComponent';
import './PricingForm.css';

import {
} from '../../actions';


class PricingForm extends OzFormComponent {

  static fields = [
    'style',
    'pricePerPerson',
    'pricePerPersonPrivate',
    // 'flatPrice',
    // 'flatPricePrivate',
  ];

  showPrivate() {
    return this.props.privacy == 'fee';
  }

  renderPerPerson() {
    return (
      <div>
        {['fee', 'no'].includes(this.props.privacy) && this.renderFormGroup('Price per person', 'number', 'pricePerPerson')}
        {['fee', 'always'].includes(this.props.privacy) && this.renderFormGroup('Price per person for private game', 'number', 'pricePerPersonPrivate')}
      </div>
    );
  }

  renderFlat() {
    return (
      <div>
        {this.renderFormGroup('Flat price', 'number', 'flatPrice')}
        {this.showPrivate() && this.renderFormGroup('Flat price for private game', 'number', 'flatPricePrivate')}
      </div>
    );
  }

  // renderVariable() {
  //   let min = this.props.minPeople;
  //   let max = this.props.maxPeople;
  //   let nodes = [];
  //   for (let i = min; i < max; i++) {
  //     let node = (
  //       <div>
  //       </div>
  //     );
  //   }
  // }

  renderBody() {
    let styleOptions = [
      ['per_person', 'Per Person'],
      ['flat', 'Flat'],
      ['variable', 'Variable'],
    ];

    return (
      <div className="PricingForm">
        {this.renderPerPerson()}

        {/*this.renderFormGroup(null, 'pills', 'style', styleOptions)*/}
        {/*this.state.style == 'per_person' && this.renderPerPerson()*/}
        {/*this.state.style == 'flat' && this.renderFlat()*/}
        {/*this.state.style == 'variable' && this.renderVariable()*/}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PricingForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/PricingForm.js
 **/